/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Source_LabelInputs */

const en_new_project_media_source_label = /** @type {(inputs: New_Project_Media_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media Source`)
};

const fr_new_project_media_source_label = /** @type {(inputs: New_Project_Media_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source media`)
};

const de_new_project_media_source_label = /** @type {(inputs: New_Project_Media_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienquelle`)
};

const it_new_project_media_source_label = /** @type {(inputs: New_Project_Media_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte multimediale`)
};

const ru_new_project_media_source_label = /** @type {(inputs: New_Project_Media_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Источник информации`)
};

const es_new_project_media_source_label = /** @type {(inputs: New_Project_Media_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuente de medios`)
};

const zh_cn2_new_project_media_source_label = /** @type {(inputs: New_Project_Media_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体来源`)
};

const ja_new_project_media_source_label = /** @type {(inputs: New_Project_Media_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアソース`)
};

const hi_new_project_media_source_label = /** @type {(inputs: New_Project_Media_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया स्रोत`)
};

const pt_pt2_new_project_media_source_label = /** @type {(inputs: New_Project_Media_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte de mídia`)
};

/**
* | output |
* | --- |
* | "Media Source" |
*
* @param {New_Project_Media_Source_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_source_label = /** @type {((inputs?: New_Project_Media_Source_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Source_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_media_source_label(inputs)
	if (locale === "de") return de_new_project_media_source_label(inputs)
	if (locale === "it") return it_new_project_media_source_label(inputs)
	if (locale === "ru") return ru_new_project_media_source_label(inputs)
	if (locale === "es") return es_new_project_media_source_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_media_source_label(inputs)
	if (locale === "ja") return ja_new_project_media_source_label(inputs)
	if (locale === "hi") return hi_new_project_media_source_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_media_source_label(inputs)
	return en_new_project_media_source_label(inputs)
});